import { z } from 'zod';

/// Sunucu env şeması. Uygulama açılışta bunu doğrular ve eksik/bozuk
/// değişkende AÇILMAZ — yarım yapılandırmayla çalışıp sonra 3'üncü günde
/// patlamasındansa hemen ölmesi iyidir.
export const serverEnvSchema = z.object({
  NODE_ENV: z.enum(['development', 'test', 'production']).default('development'),

  DATABASE_URL: z.string().startsWith('postgresql://'),
  REDIS_URL: z.string().startsWith('redis://'),

  API_PORT: z.coerce.number().int().positive().default(3040),
  WORKER_METRICS_PORT: z.coerce.number().int().positive().default(3042),

  // Tarayıcının gördüğü adresler. API ayrı alan adında (api.mentorivo.com);
  // WEB_URL hem CORS izin listesi hem de e-postadaki bağlantıların kökü.
  WEB_URL: z.url(),
  API_PUBLIC_URL: z.url(),

  // Çerezin yazıldığı alan adı. Başında nokta olmalı (`.mentorivo.com`) —
  // web ve API farklı alt alan adlarında olduğu için host'a özel çerez
  // ikisinden yalnızca birine gider. Yerel geliştirmede boş bırakılırsa
  // çerez host'a özel yazılır, o da tek origin'de çalışır.
  COOKIE_DOMAIN: z.string().optional(),

  JWT_SECRET: z.string().min(32, 'JWT_SECRET en az 32 karakter olmalı'),
  JWT_ACCESS_TTL: z.string().default('15m'),
  JWT_REFRESH_TTL: z.string().default('30d'),

  // AES-256-GCM anahtarı: 32 bayt = 64 hex karakter.
  TOKEN_VAULT_KEY: z
    .string()
    .regex(/^[0-9a-f]{64}$/i, 'TOKEN_VAULT_KEY 64 hex karakter olmalı (32 bayt)'),

  // Faz 1+ — henüz başvuru sürecinde olabilir, o yüzden opsiyonel.
  META_APP_ID: z.string().optional(),
  META_APP_SECRET: z.string().optional(),
  META_API_VERSION: z.string().default('v24.0'),
  /// Facebook Login for Business yapılandırma kimliği. OAuth akışı bunu
  /// `config_id` olarak gönderiyor; olmadan izin ekranı klasik kipte açılır.
  META_CONFIG_ID: z.string().optional(),
  /// İzin ekranına gönderilen geri dönüş adresi. Meta konsolundaki
  /// "Valid OAuth Redirect URIs" ile BİREBİR aynı olmak zorunda.
  /// Boşsa `API_PUBLIC_URL` üzerinden temiz yol üretilir; dolu olmasının tek
  /// sebebi bu alan adının önceki kurulumundan kalma kaydın hâlâ geçerli
  /// olması — kullanıcıya konsola girme işi çıkarmamak için.
  META_REDIRECT_URI: z.string().optional(),

  GOOGLE_ADS_CLIENT_ID: z.string().optional(),
  GOOGLE_ADS_CLIENT_SECRET: z.string().optional(),
  GOOGLE_ADS_DEVELOPER_TOKEN: z.string().optional(),
  /// Yönetici (MCC) hesabı. Google Ads API'de alt hesaplara bu kimlik
  /// üzerinden erişiliyor; `login-customer-id` başlığı olarak gidiyor.
  GOOGLE_ADS_LOGIN_CUSTOMER_ID: z.string().optional(),
  /**
   * İzin ekranına gönderilen geri dönüş adresi — `META_REDIRECT_URI` ile aynı
   * gerekçe ve aynı geçmiş.
   *
   * 🔴 Google Cloud Console'daki OAuth istemcisi eski kurulumdan (APEX
   * GrowthOS) kalma ve `GOOGLE_ADS_CLIENT_ID` onunla AYNI — yani "Authorized
   * redirect URIs" listesinde duran adres `/api/v1` önekli:
   *
   *     https://api.mentorivo.com/api/v1/integrations/google/callback
   *
   * Bizim API'de önek yok, o yüzden bu değişken olmadan kod temiz yolu üretir
   * ve Google `redirect_uri_mismatch` döner — ekran hangi parçanın yanlış
   * olduğunu SÖYLEMEZ, hata ayıklaması pahalıdır. Controller iki yolu da
   * dinlediği için geri dönüş yine karşılanıyor.
   */
  GOOGLE_REDIRECT_URI: z.string().optional(),

  /**
   * Google Merchant Center'ın AYRI geri dönüş adresi — 19 Ağu 2026.
   *
   * 🔴 `GOOGLE_REDIRECT_URI` ile aynı değer OLAMAZ. Google izin ekranına
   * giden adresle kod takasındaki adresin birebir aynı olmasını şart koşuyor
   * ve iki akış (Ads / Merchant) farklı kapsam istiyor; tek adres paylaşmak,
   * callback'te "bu kod hangi akışa ait" sorusunu cevapsız bırakırdı.
   *
   * ⚠️ Değer sunucuda ÖLÇÜLDÜ (19 Ağu 2026, kontrol grubuyla):
   *
   *     https://api.mentorivo.com/api/v1/integrations/google-merchant/callback   ✅ kayıtlı
   *     https://api.mentorivo.com/integrations/google-merchant/callback          🔴 kayıtlı DEĞİL
   *
   * Yani ÖNEKLİ biçim zorunlu ve bu değişken boş bırakılamaz — kodun ürettiği
   * temiz yol (`API_PUBLIC_URL` + `/integrations/google-merchant/callback`)
   * `redirect_uri_mismatch` alır. Kayıt eski APEX GrowthOS kurulumundan
   * kalma; OAuth istemcisi (`GOOGLE_ADS_CLIENT_ID`) o projeyle birebir aynı
   * olduğu için Console'da yapılacak iş YOK.
   *
   * Bu yüzden `PLATFORM_ENV_KEYS` karşılığında ZORUNLU sayılıyor (LinkedIn ve
   * TikTok'la aynı gerekçe): boş bırakılıp "yönetici yapılandırmalı"
   * görünmesi, izin ekranının sessizce hiç açılmamasına yeğdir.
   */
  GOOGLE_MERCHANT_REDIRECT_URI: z.string().optional(),

  TIKTOK_APP_ID: z.string().optional(),
  TIKTOK_APP_SECRET: z.string().optional(),
  /**
   * Genişleme Adım 4 — TikTok Ads.
   *
   * 🔴 Değer `.env`'de ZATEN VARDI, şemada tanımlı olmadığı için sessizce
   * DÜŞÜYORDU: `parseServerEnv` bilinmeyen anahtarı hata vermeden atıyor, yani
   * `env.TIKTOK_REDIRECT_URI` tipsiz `undefined`dı. Sonucu kod okunarak
   * görülmüyordu — yalnızca izin ekranı açıldığında `redirect_uri` uyuşmazlığı
   * olarak patlıyordu.
   *
   * TikTok konsolundaki kayıt `/api/v1` önekli:
   *
   *     https://api.mentorivo.com/api/v1/integrations/tiktok/callback
   *
   * Bizim API'de önek yok — bu değişken olmadan `OAuthService.redirectUri()`
   * öneksiz temiz yolu üretir ve TikTok izin ekranı hiç açılmaz. Controller
   * iki biçimi de dinliyor (`@Controller(['integrations','api/v1/integrations'])`),
   * dönüş yolu sorun değil; sorun GİDEN adresin birebir eşleşmesi.
   *
   * `META_REDIRECT_URI` ile aynı gerekçe, `LINKEDIN_REDIRECT_URI` gibi ZORUNLU
   * DEĞİL: burada boş kalırsa üretilen temiz yol yanlış olur ama uygulama
   * açılmaya devam etmeli — "eksik" kararını `PLATFORM_ENV_KEYS` veriyor.
   */
  TIKTOK_REDIRECT_URI: z.string().optional(),

  // ── Genişleme Adım 5 — LinkedIn Ads ─────────────────────────────────────
  //
  // Üçü de `.optional()`: anahtar yokken uygulama AÇILMAYA devam etmeli ve
  // kart "yönetici yapılandırmalı" demeli (Meta/Google deseni). Şemayı zorunlu
  // yapmak, LinkedIn kullanmayan bir kurulumda API'nin hiç açılmaması demekti.
  LINKEDIN_CLIENT_ID: z.string().optional(),
  LINKEDIN_CLIENT_SECRET: z.string().optional(),
  /**
   * 🔴 Bu değişken LinkedIn'de ZORUNLU sayılıyor (`PLATFORM_ENV_KEYS.LINKEDIN`),
   * Meta ve Google'da opsiyonel olduğu hâlde. Zod'da yine `.optional()` çünkü
   * boş olması uygulamayı açılmaz kılmamalı; "eksik" kararını registry veriyor.
   *
   * Fark şurada: Meta/Google'da değişken boşsa kodun ürettiği temiz yol
   * (`API_PUBLIC_URL` + `OAUTH_CALLBACK_PATH`) DOĞRU cevaptır. LinkedIn'de doğru
   * cevabı yalnızca Developer Portal'a bakan insan biliyor — eski proje kaydı
   * `/api/v1` önekli ve LinkedIn BİREBİR eşleşme arıyor. Yanlış tahmin, izin
   * ekranının hiç açılmaması demek ve hata hangi parçanın yanlış olduğunu
   * SÖYLEMİYOR. Boş bırakılıp "yapılandırılmamış" görünmesi buna yeğdir.
   */
  LINKEDIN_REDIRECT_URI: z.string().optional(),
  /**
   * `YYYYMM`. Boşsa adapter `LINKEDIN_DEFAULT_API_VERSION` (202607) kullanıyor.
   *
   * 🔴 Koda gömülmemesinin sebebi: LinkedIn varsayılan sürüm uygulamıyor ve her
   * sürüm ~1 yıl sonra sunset oluyor (o gün API 426 dönüyor ve çözüm jeton
   * yenilemek değil deploy yapmak). Yılda bir kez zorunlu olan bu yükseltmenin
   * tek satırlık bir env değişikliğiyle çözülebilmesi gerekiyor. Eski proje
   * sabiti ALTI ayrı dosyaya kopyalamıştı.
   *
   * `PLATFORM_ENV_KEYS`e YAZILMIYOR — boş olması bir eksiklik değil, varsayılanı
   * kabul etmek demek.
   */
  LINKEDIN_API_VERSION: z.string().optional(),

  // ── Genişleme Adım 6 — X (Twitter) Ads ──────────────────────────────────
  //
  // 🔴 OAuth **1.0a**. Diğer dört platformun tamamı OAuth 2.0 kullanıyor ve
  // bunun env üzerindeki görünür sonucu isimlendirme: 1.0a'da "client" değil
  // **consumer** var, ve `_SECRET` bir istemci sırrı değil bir İMZA
  // ANAHTARIDIR — her isteğin HMAC-SHA1 imzasına giriyor, gövdede hiç
  // gönderilmiyor. `TWITTER_CLIENT_ID` diye yeniden adlandırmak, sonraki
  // okuyanı "neden `client_secret` gövdede yok" diye aratırdı.
  //
  // ⚠️ Consumer anahtarları X portalında REGENERATE EDİLİRSE mevcut Access
  // Token'lar da kopar — kayıtlı bütün kullanıcı bağlantıları ölür.
  TWITTER_CONSUMER_KEY: z.string().optional(),
  TWITTER_CONSUMER_SECRET: z.string().optional(),
  /**
   * 🔴 `TWITTER_REDIRECT_URI` BİLEREK YOK — ve bu, Meta/Google/TikTok/LinkedIn
   * dördünden de AYRILDIĞIMIZ tek yer.
   *
   * Orada değişken var çünkü portala kayıtlı adresin ne olduğu sunucudan
   * doğrulanamıyordu (eski kurulumdan kalma `/api/v1` önekli kayıtlar). X'te
   * bu SORU CEVAPLANDI: 1.0a'nın ilk adımı (`POST oauth/request_token`)
   * callback adresini SUNUCU TARAFINDA doğruluyor ve kayıtlı değilse
   * `403 code=415 "Callback URL not approved"` döndürüyor. 14 Ağu 2026'da
   * ölçüldü — kodun ürettiği temiz yol
   *
   *     https://api.mentorivo.com/integrations/twitter/callback
   *
   * `oauth_callback_confirmed=true` ile kabul edildi, kayıtlı olmayan bir
   * adres aynı çağrıda reddedildi (kontrol grubu). Yani bir env değişkeni
   * eklemek, ölçülmüş bir gerçeğin üstüne elle ezme imkânı koymak olurdu.
   */
  /**
   * `POST oauth/access_token` sonrası jeton SAHİBİNİ okumak için gereken
   * uygulama sahibi jetonları DEĞİL — bunlar yalnız YOKLAMA/doğrulama içindir.
   *
   * 🔴 Kullanıcı bağlantıları OAuth akışından gelir, BUNLARDAN DEĞİL. Kodun
   * hiçbir yeri bu ikisini okumuyor; `.env`'de durmalarının tek sebebi
   * `scripts`/elle yoklama. Şemaya yazılmalarının sebebi de tam tersi bir
   * kaza: şemada olmayan bir anahtar `parseServerEnv` tarafından SESSİZCE
   * atılıyor (TikTok'ta `TIKTOK_REDIRECT_URI` ile birebir bu yaşandı) ve
   * "`.env`'de var ama `env.X` undefined" hatası kod okunarak görülmüyor.
   */
  TWITTER_OWNER_ACCESS_TOKEN: z.string().optional(),
  TWITTER_OWNER_ACCESS_TOKEN_SECRET: z.string().optional(),
  /// Yoklama hesabı (`18ce55wz77k`). Üretim yolunda KULLANILMIYOR.
  TWITTER_TEST_ACCOUNT_ID: z.string().optional(),
  /**
   * Ads API sürümü. Boşsa adapter `TWITTER_DEFAULT_API_VERSION` (12) kullanır.
   *
   * `LINKEDIN_API_VERSION` ile AYNI gerekçe ve aynı ölçüm: sürüm numarası
   * isteğin YOLUNUN İÇİNDE ve eskiyen sürüm kapatılıyor. 14 Ağu 2026'da
   * ölçüldü: `/11` hâlâ 200 dönüyor, `/13` ise
   * `403 "Version 13.0 is not available."` — yani 13 açıldığı gün bu tek
   * satırla geçilebilmeli, deploy ile değil.
   *
   * ⚠️ Ana bilgisayar adı BİLEREK yazılmadı: adapter sınırı denetimi
   * (`grep`) X'e özgü sözcüklerin `connector/twitter/` dışında geçmediğini
   * ölçüyor ve bir yorum da o denetimi kırar. Adres `twitter.client.ts`te.
   *
   * `PLATFORM_ENV_KEYS`e YAZILMIYOR: boş olması bir eksiklik değil,
   * varsayılanı kabul etmek demek (`LINKEDIN_API_VERSION` ile aynı karar).
   */
  TWITTER_API_VERSION: z.string().optional(),

  // ── Genişleme Adım 1 — Shopify (mağaza) ─────────────────────────────────
  //
  // 🔴 Bunlar REKLAM platformu anahtarı DEĞİL. Shopify bir mağaza platformu;
  // `StorePlatform` enum'ında, `AdPlatform`ta değil. `PLATFORM_ENV_KEYS`e
  // yazılmıyorlar — o tablo `Record<AdPlatform, …>` ve yönetici panelindeki
  // reklam platformu kartlarını besliyor. Mağaza kartlarının karşılığı
  // `STORE_PLATFORM_ENV_KEYS`.
  //
  // Değerler eski projenin `.env`'inde VAR (`SHOPIFY_API_KEY` /
  // `SHOPIFY_API_SECRET`) ama bugünküne TAŞINMADI — kullanıcı taşıyacak.
  // Boşken adapter `available: false` bildiriyor ve kart "yönetici
  // yapılandırmalı" diyor; sessizce çalışmıyor gibi görünmüyor.
  /**
   * ETSY — uygulama düzeyi anahtar (keystring), kiracı başına DEĞİL.
   *
   * 🔴 Kimlik blob'una girmez ve girmemeli: her satıcı aynı keystring'i
   * kullanıyor, bizim uygulamamızın kimliği o. Blob'a koysaydık aynı değer
   * yüzlerce satırda şifreli olarak tekrar eder ve döndürmek her satırı
   * yeniden yazmayı gerektirirdi.
   *
   * ⚠️ Etsy jeton ucu `client_secret` KABUL ETMİYOR (PKCE) — yani bu tek
   * değer hem izin ekranı hem jeton yenileme için yeterli.
   */
  ETSY_KEYSTRING: z.string().optional(),
  /**
   * AMAZON SP-API — üçü de UYGULAMA düzeyi (kiracı başına değil).
   *
   * `AMAZON_SP_APP_ID` izin ekranının adresini kuruyor; LWA çifti jeton
   * takası ve yenileme için. Üçü birden dolu değilse Amazon kartı
   * "yönetici yapılandırmalı" durumunda kalıyor — `isImplemented` ile
   * KARIŞTIRILMAMALI: adapter yazıldı, eksik olan yapılandırma.
   */
  AMAZON_SP_APP_ID: z.string().optional(),
  AMAZON_LWA_CLIENT_ID: z.string().optional(),
  AMAZON_LWA_CLIENT_SECRET: z.string().optional(),
  SHOPIFY_API_KEY: z.string().optional(),
  SHOPIFY_API_SECRET: z.string().optional(),
  /// İzin ekranına gönderilen geri dönüş adresi. Shopify Partner panelindeki
  /// "Allowed redirection URL(s)" listesiyle BİREBİR aynı olmak zorunda —
  /// `META_REDIRECT_URI` ile aynı gerekçe. Boşsa `API_PUBLIC_URL` üzerinden
  /// temiz yol üretiliyor.
  SHOPIFY_REDIRECT_URI: z.string().optional(),

  ANTHROPIC_API_KEY: z.string().optional(),
  /// fal.ai — Flux görsel üretimi (tasarım §4.4, sağlayıcı seçimi Faz 4'te
  /// kesinleşecek). Eski kurulumdan devralındı, `CreativeProvider`
  /// soyutlamasının arkasında kalacak.
  FAL_KEY: z.string().optional(),

  /**
   * ÖDEME SAĞLAYICISI: İYZİCO (Faz 8, 12 Ağu 2026).
   *
   * Öncesinde burada `STRIPE_SECRET_KEY` / `STRIPE_WEBHOOK_SECRET` duruyordu.
   * Stripe Türkiye'de yerel kart ve taksit desteği vermiyor; ürünün ilk pazarı
   * Türkiye olduğu için sağlayıcı iyzico seçildi ve o iki değişken SİLİNDİ —
   * ölü bir env anahtarı bırakmak, altı ay sonra ".env'de Stripe var, demek ki
   * bir yerde kullanılıyor" yanılgısını doğururdu.
   *
   * 🔴 Üç değişken de OPSİYONEL ve bugün .env'de YOK. Anahtar yokken
   * `BillingModule` `NullPaymentProvider`ı devreye alıyor ve ödeme uçları
   * tipli `PAYMENT_NOT_CONFIGURED` (HTTP 503) dönüyor. Anahtarı kullanıcı
   * kendi yapıştıracak; hiçbir kod .env'e yazmıyor.
   *
   * `IYZICO_SECRET_KEY` İKİ İŞ birden yapıyor: giden isteğin `IYZWSv2`
   * imzasının HMAC anahtarı VE gelen webhook'un `X-IYZ-SIGNATURE-V3`
   * doğrulamasının anahtarı. Ayrı bir webhook sırrı YOK (Stripe'ın aksine) —
   * dördüncü bir değişken tanımlamak, doldurulmadığında webhook'u sessizce
   * reddeden bir tuzak olurdu.
   */
  IYZICO_API_KEY: z.string().optional(),
  IYZICO_SECRET_KEY: z.string().optional(),
  /// Sandbox varsayılan: gerçek para hareketi ancak bilinçli olarak
  /// `https://api.iyzipay.com` yazılınca başlar. Ters varsayılan (production)
  /// yanlış yapılandırmayı gerçek tahsilata çevirirdi.
  IYZICO_BASE_URL: z.string().default('https://sandbox-api.iyzipay.com'),

  /// Ajan modeli. Kalıcı bir ayar deposu (PlatformSetting) olmadığı için
  /// model seçimi bugün env'den geliyor; `/admin/ai` onu SALT OKUNUR gösterir.
  AGENT_MODEL: z.string().default('claude-sonnet-4-5'),
  /**
   * ÜRÜN FOTOĞRAFI OKUMA MODELİ — `AGENT_MODEL`den AYRI ve bilerek daha hızlı.
   *
   * ═══════════════════════════════════════════════════════════════════════
   * Neden ikinci bir model ayarı
   * ═══════════════════════════════════════════════════════════════════════
   * "Aynı sorunun iki cevabı olmasın" kuralı (`anthropic-text.provider.ts` →
   * `FALLBACK_MODEL`) burada geçerli DEĞİL, çünkü soru aynı değil:
   *
   *   · Konsept üretimi bir YARATIM işi — üç farklı reklam fikri kurup
   *     aralarında seçim yapılabilir hâle getiriyor. Büyük model orada
   *     karşılığını veriyor.
   *   · Ürün okuması bir AYIKLAMA işi — fotoğrafta ne olduğunu adlandırıp
   *     strict şemaya dolduruyor. Şema zaten grameri kısıtlıyor, yani çıktının
   *     ŞEKLİ modele bırakılmış değil.
   *
   * Kullanıcının ölçtüğü şey buydu: sihirbazda tek bir cümle için Opus
   * bekletiyordu. Okuma kullanıcının GÖZÜNÜN ÖNÜNDE koşuyor (sihirbaz açık,
   * düğmeye basılmış) — orada saniyeler görünür, konsept üretiminde değil.
   *
   * ⚠️ Değiştirilecekse ARAÇ KULLANIMINI ve GÖRSEL girdiyi destekleyen bir
   * model olmalı; ikisi de zorunlu (`strict: true` + `image` bloğu).
   */
  VISION_READING_MODEL: z.string().default('claude-haiku-4-5-20251001'),

  S3_ENDPOINT: z.string().optional(),
  S3_REGION: z.string().default('auto'),
  S3_BUCKET: z.string().optional(),
  S3_ACCESS_KEY_ID: z.string().optional(),
  S3_SECRET_ACCESS_KEY: z.string().optional(),
  /// İmzalı URL'lerin kökü (R2 özel alan adı). Boşsa `S3_ENDPOINT` üzerinden
  /// imzalanır. Bucket ASLA public değil — bu yalnızca imzanın konacağı ana
  /// bilgisayar adı.
  S3_PUBLIC_BASE_URL: z.string().optional(),

  /// PDF üretimi için headless Chrome ikilisinin yolu. Boşsa rapor PDF ucu
  /// `PDF_NOT_CONFIGURED` döner — sessizce boş dosya üretmez.
  PDF_RENDER_BIN: z.string().optional(),

  // Posta gönderimi Yandex 360 üzerinden: mentorivo.com'un MX'i zaten
  // mx.yandex.net ve SPF `redirect=_spf.yandex.net` diyor. Bu sunucudan
  // doğrudan göndermek SPF'i geçemez, DMARC `p=quarantine` olduğu için de
  // doğrulama maili spam'e düşer. Yandex üzerinden gönderince hizalı olur.
  //
  // SMTP_HOST boşsa mail gerçekten gönderilmez; bağlantı sunucu loguna yazılır.
  // Geliştirme sırasında kimlik bilgisi olmadan akışı test edebilmek için.
  SMTP_HOST: z.string().optional(),
  SMTP_PORT: z.coerce.number().int().default(465),
  SMTP_SECURE: z
    .string()
    .default('true')
    .transform((v) => v !== 'false'),
  SMTP_USER: z.string().optional(),
  SMTP_PASS: z.string().optional(),
  // Gönderen adresi SMTP_USER'dan farklı olabilir (takma ad), ikisi de
  // aynı alan adında olmalı yoksa DKIM hizalaması bozulur.
  SMTP_FROM: z.string().default('Mentorivo <noreply@mentorivo.com>'),

  // ═════════════════════════════════════════════════════════════════════════
  // BACKSTAGE — platform yönetim paneli
  // ═════════════════════════════════════════════════════════════════════════

  /// Panelin tarayıcıdan görünen kökü. Yalnızca bu host'tan gelen istekler
  /// backstage rotalarını görüyor (`proxy.ts` host bağı) ve TOTP QR kodundaki
  /// hesap etiketi buradan üretiliyor.
  BACKSTAGE_URL: z.url().default('https://backstage.mentorivo.com'),

  /// 🔴 Ürün JWT'sinden AYRI sır. Aynı olsaydı `JWT_SECRET` sızdığında panel
  /// de açılırdı — oysa panelin tek amacı ürün tarafındaki bir sızıntının
  /// buraya ULAŞMAMASI. Panel oturumu jeton değil opaque bir dize kullanıyor
  /// ama bu sır oturum jetonunun HMAC'inde ve TOTP zorluk anahtarında geçiyor.
  BACKSTAGE_SECRET: z.string().min(32, 'BACKSTAGE_SECRET en az 32 karakter olmalı'),

  /// Acil durum ağı — panelden SİLİNEMEZ, IP kural listesine her zaman
  /// eklenir. Virgülle ayrılmış CIDR listesi.
  ///
  /// Neden var: IP zorlaması açıkken yanlış bir kural yazmak yöneticiyi kendi
  /// panelinden kilitler ve düzeltmenin tek yolu sunucuya SSH ile girip
  /// veritabanını elle düzenlemek olur. Bu değer o senaryoyu ortadan
  /// kaldırıyor — sunucunun kendi IP'si ve yöneticinin sabit hattı burada
  /// durur.
  BACKSTAGE_BREAKGLASS_CIDR: z.string().default('127.0.0.1/32'),

  /// nginx allow/deny bloğunun yazılacağı dosya. Boşsa nginx senkronu
  /// tamamen kapalı (uygulama katmanı yine çalışır).
  BACKSTAGE_NGINX_CONF: z
    .string()
    .default('/var/www/vhosts/system/backstage.mentorivo.com/conf/vhost_nginx.conf'),
});

export type ServerEnv = z.infer<typeof serverEnvSchema>;

// NodeJS.ProcessEnv yerine yapısal tip: bu paket frontend'de de derleniyor,
// @types/node'a bağlanmamalı.
export function parseServerEnv(
  raw: Record<string, string | undefined> | Record<string, unknown>,
): ServerEnv {
  const result = serverEnvSchema.safeParse(raw);
  if (!result.success) {
    const issues = result.error.issues
      .map((i) => `  - ${i.path.join('.')}: ${i.message}`)
      .join('\n');
    throw new Error(`Ortam değişkenleri geçersiz:\n${issues}`);
  }
  return result.data;
}
